(function(angular){
	'use strict';
	
	angular
		.module('hypotheticalPerformanceChartModule')
		.directive('hypotheticalPerformanceChart', [
			'$timeout', 
			'$window',
			'Big',
			'HIGHCHARTS_OPTIONS', 
			'STATIC_BASE_PATH',
			hypotheticalPerformanceChartFunction
		]);

	function hypotheticalPerformanceChartFunction(
		$timeout, 
		$window,
		Big,
		HIGHCHARTS_OPTIONS, 
		STATIC_BASE_PATH
	) {
		return {
			templateUrl: STATIC_BASE_PATH + '/static/html/shared/charts/hypothetical-performance/hypothetical-performance-chart.html',
			restrict: 'E',
			replace: true,
			scope: {
				fundrisePortfolio: '=',
				maxHypotheticalReturnPerPeriod: '=',
				periods: '=',
				principal: '=',
				dashboardChart: '=',
				historicalReturns: '=?',
				totalEarnings: '=?',
				paddingBottom: '@',
				projectedAccountValue: '=',
				theme: '@?'
			},
			link: {
				post: function($scope, $element, $attrs) {
					Highcharts.setOptions(HIGHCHARTS_OPTIONS('dark'));
					
					var historicalSeriesColor;
					var chartLineColor;
					var chartLabelColor;
					
					if ($scope.theme === 'light') {
						historicalSeriesColor = "#000000";
						chartLineColor = "hsl(210,10%,90%)";
						chartLabelColor = "hsl(210,5%,55%)";
					} else {
						historicalSeriesColor = "#ffffff";
						chartLineColor = "rgba(255,255,255,0.1)";
						chartLabelColor = "rgba(255,255,255,0.5)";
					}
					
					$scope.historicalSeriesColor = historicalSeriesColor;

					var chartSeries = [{
						id: 'fundriseVariationHigh',
						type: 'arearange',
						color: 'transparent',
						fillColor: {
							linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
							stops: [
								[0, Highcharts.Color('#007fff').setOpacity(0.6).get('rgba')],
								[0.75, Highcharts.Color('#007fff').setOpacity(0).get('rgba')]
							]
						},
						variation: 0.5
					},{
						id: 'fundriseVariationMed',
						type: 'arearange',
						color: 'transparent',
						fillColor: {
							linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
							stops: [
								[0.4, Highcharts.Color('#F47735').setOpacity(0.8).get('rgba')],
								[0.95, Highcharts.Color('#F47735').setOpacity(0).get('rgba')]
							]
						},
						variation: 0.25
					},{
						id: 'fundriseVariationLow',
						type: 'arearange',
						color: 'transparent',
						fillColor: {
							linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
							stops: [
								[0.5, Highcharts.Color('#FFCE7D').setOpacity(1).get('rgba')],
								[0.95, Highcharts.Color('#F6A01A').setOpacity(0).get('rgba')]
							]
						},
						variation: 0.1
					}];
					
					if (!$scope.dashboardChart) {
						chartSeries.push({
							id: 'fundriseBaseline',
							type: 'line',
							color: {
								linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
								stops: [
									[0.5, '#F6A01A'],
									[1, '#F6A01A']
								]
							},
							marker: {
								enabled: false,
								fillColor: '#F6A01A',
								radius: 4,
								symbol: 'circle'
							}
						});
					} else {
						chartSeries.push({
							id: "historicalReturns",
							color: historicalSeriesColor,
							type: "line",
							marker: {
								enabled: false
							},
							showInLegend: false,
							zIndex: 10
						});
					}
					
					var getReturnValues = function(series) {
						var returnValues = [];
						var now = moment().valueOf();
						var periods = Number($scope.periods);
						var principal = new Big($scope.principal);

						var hypotheticalReturnPerPeriod = new Big(0);
						if(typeof($scope.fundrisePortfolio) !== 'undefined') {
							hypotheticalReturnPerPeriod = new Big($scope.fundrisePortfolio.projectedQuarterlyReturnMidpoint);
						}
						
						for(var i = 0; i < periods + 1; i++) {
							var period = i;
							var point = {};

							now = moment(now).add(3, 'M').valueOf();
							point.x = now;

							if(series.type === 'arearange') {
								var returnVariation = hypotheticalReturnPerPeriod.times(new Big(series.variation));
								
								point.high = (new Big(1)).plus(hypotheticalReturnPerPeriod).plus(returnVariation).pow(period).times(principal);
								point.low = (new Big(1)).plus(hypotheticalReturnPerPeriod).minus(returnVariation).pow(period).times(principal);
								
								if ($scope.dashboardChart) {
									point.high = point.high.minus(principal).plus($scope.totalEarnings);
									point.low = point.low.minus(principal).plus($scope.totalEarnings);
								}

								point.high = Number(point.high);
								point.low = Number(point.low);
							} else if(series.id === 'fundriseBaseline') {
								point.y = (new Big(1).plus(hypotheticalReturnPerPeriod).pow(period).times(principal));

								if ($scope.dashboardChart) {
									point.y = point.y.minus(principal).plus($scope.totalEarnings);
								}

								point.y = Number(point.y);

								if(i === periods) {
									point.marker = {
										enabled: true
									};
								}
							}

							returnValues.push(point);
						}

						return returnValues;
					};

					var yAxisMax = function() {
						var yAxisMax;
						var maxHypotheticalReturnPerPeriod;
						if(angular.isDefined($scope.maxHypotheticalReturnPerPeriod)) {
							 maxHypotheticalReturnPerPeriod = new Big($scope.maxHypotheticalReturnPerPeriod);
						} else {
							maxHypotheticalReturnPerPeriod = new Big(1);
						}
						var periods = Number($scope.periods);
						var principal = new Big($scope.principal);

						yAxisMax = (new Big(1).plus(maxHypotheticalReturnPerPeriod).pow(periods).times(principal));


						return Number(yAxisMax);
					};
					
					var chart;
					
					function initializeChart(){
						chart = new Highcharts.Chart({
							chart: {
								renderTo: 'hypothetical-performance-chart',
								spacing: [0, 0, 0, 0]
							},
							plotOptions: {
								series: {
									animation: {
										duration: 500
									},
									states: {
										hover: {
											enabled: false
										}
									}
								}
							},
							series: chartSeries,
							xAxis: {
								type: 'datetime',
								allowDecimals: false,
								tickColor: chartLineColor,
								lineColor: chartLineColor,
								labels: {
									formatter: function() {
										return moment(this.value).format('YYYY');
									},
									style: {
										color: chartLabelColor
									}
								}
							},
							yAxis: {
								endOnTick: $scope.dashboardChart ? false : true,
								gridLineColor: chartLineColor,
								labels: {
									formatter: function() {
										return '$' + Highcharts.numberFormat(this.value / 1000, 0) + 'K';
									},
									style: {
										color: chartLabelColor
									}
								},
								min: 0,
								startOnTick: $scope.dashboardChart ? true : false,
								tickPixelInterval: $scope.dashboardChart ? 72 : 48
							}
						});
					}

					$scope.$watch('[principal,periods,fundrisePortfolio,historicalReturns]', function() {
						
						if($scope.principal !== '0') {
							$timeout(function() {
								initializeChart();

								if (typeof($scope.historicalReturns) !== 'undefined' && $scope.historicalReturns.data.length > 0){

									angular.forEach(chartSeries, function(series, index){
										var historicalReturnsData = $scope.historicalReturns.data;
										
										if (series.id === 'historicalReturns') {
											chart.series[index].setData(historicalReturnsData);
										} else {
											var seriesData = getReturnValues(series);
											chart.series[index].setData(seriesData);
										}
									});

									chart.update({
										yAxis: {
											max: yAxisMax()
										},
										xAxis: {
											plotLines: [{
												color: 'rgba(255,255,255,0.5)',
												value: $scope.historicalReturns.plotLineX,
												width: 1
											}]
										}
									});
								} else {
									chart.update({
										yAxis: {
											min: $scope.principal,
											max: yAxisMax()
										}
									});
									
									while(chart.series.length > 0) {
										chart.series[0].remove(true);
									}

									angular.forEach(chartSeries, function(series, index) {
										series.data = getReturnValues(series);
										chart.addSeries(series);
									});
									
									$scope.calloutStyle = {
										top: chart.series[3].data[$scope.periods].plotY + chart.plotTop + 'px',
										left: chart.series[3].data[$scope.periods].plotX + chart.plotLeft + 'px'
									};
								}
							});				
						}
					}, true);
				}
			}
		};
	}
})(window.angular);